module.exports = __webpack_public_path__ + "static/media/hp-home-banner-tablet-@1x.5edf9d59.jpg";